var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, EventEmitter, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { DomainService } from 'app/services/domain.service';
import { ResolutionCenterService } from 'app/services/resolution-center.service';
import { ResolutionQcService } from 'app/services/resolution-qc.service';
var ResolutionDAVComponent = /** @class */ (function () {
    function ResolutionDAVComponent(elemRef, activityService, attrIndexService, domainService, resoCenterService, resoQcService) {
        this.elemRef = elemRef;
        this.activityService = activityService;
        this.attrIndexService = attrIndexService;
        this.domainService = domainService;
        this.resoCenterService = resoCenterService;
        this.resoQcService = resoQcService;
        this.edit = new EventEmitter();
        this.addrList = [];
        this.cols = [];
        this.rules = [];
    }
    ResolutionDAVComponent.prototype.clickAddr = function (addr) {
        var _this = this;
        this.addrList.forEach(function (a) {
            a.isCurrent = a === addr;
            if (a.isCurrent) {
                _this.currentAddr = a;
            }
        });
    };
    ResolutionDAVComponent.prototype.onEditCell = function (idx, e) {
        // this.addrList[idx].props[e.col.prop] = e.val;
        this.resoCenterService.onEditRecord(this.addrList[idx], e.col);
        this.edit.emit({
            changedCols: [e.col]
        });
        // const addressQcCodes = this.resoQcService.qcCheckAddress(this.addrList, [e.col.prop], this.cols.map(c => c.prop));
        // const generalQcCodes = this.resoQcService.qcCheckGeneral(this.addrList, this.cols, this.elemRef);
        // addressQcCodes.concat(generalQcCodes).forEach(i => {
        // 	const rule = this.rules.find(r => r.code === i.code);
        // 	if (rule) {
        // 		rule.isFixed = !i.isFailed;
        // 	} else {
        // 		this.rules.push({
        // 			code: i.code,
        // 			isFixed: !i.isFailed
        // 		})
        // 	}
        // });
    };
    ResolutionDAVComponent.prototype.onFeedChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var layerCateCode, _a, addrList, layerCate, colsForDomain;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.resolverFeed) {
                            this.addrList = [];
                            this.cols = [];
                            this.rules = [];
                            return [2 /*return*/];
                        }
                        layerCateCode = Object.keys(this.resolverFeed.feed)[0];
                        //
                        _a = this;
                        return [4 /*yield*/, this.resoCenterService.transformCols(this.resolverFeed.feed[layerCateCode].cols, layerCateCode)];
                    case 1:
                        //
                        _a.cols = _b.sent();
                        return [4 /*yield*/, this.resoCenterService.transformItemList(this.resolverFeed, layerCateCode)];
                    case 2:
                        addrList = _b.sent();
                        layerCate = this.activityService.selectedLayerBS.getValue().layer.category;
                        colsForDomain = this.cols.map(function (c) {
                            return {
                                prop: c.prop,
                                standard: layerCate.standardCols.find(function (s) { return s.colName === c.standardName; })
                            };
                        });
                        this.addrList = addrList.map(function (i) {
                            var domainsByColumn = _this.domainService.getColumnDomains(colsForDomain, layerCate.code, i.props);
                            return Object.assign(i, {
                                domainsByColumn: domainsByColumn
                            });
                        });
                        this.rules = this.resoCenterService.transformRules(this.resolverFeed.rules);
                        return [2 /*return*/];
                }
            });
        });
    };
    ResolutionDAVComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    ResolutionDAVComponent.prototype.ngOnChanges = function (changes) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!changes.resolverFeed) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.onFeedChange()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return ResolutionDAVComponent;
}());
export { ResolutionDAVComponent };
